import React, {lazy, Suspense} from "react";
import {Route, Switch} from "react-router-dom";
import MyRouter from "router/router";
import * as css from "./css/content";
import Loading from "components/loading/Loading";
import PayNav from "pages/order/partials/pay-nav/PayNav";
import PaySuccess from "pages/pay-success/PaySuccess";
import WxPay from 'pages/wx-pay/WxPay';

const Home = lazy(() => import("pages/home/Home"));
const Self = lazy(() => import("pages/self/Self"));
const ShopStreet = lazy(() => import("pages/shop-street/ShopStreet"));
const Shop = lazy(() => import("pages/shop/Shop"));
const News = lazy(() => import("pages/news/News"));
const Merchant = lazy(() => import("pages/merchant/Merchant"));
const Introduce = lazy(() => import("pages/introduce/Introduce"));
const Order = lazy(() => import("pages/order/Order"));
const View = lazy(() => import("pages/view/View"));
const Collection = lazy(() => import("pages/collection/Collection"));
const Service = lazy(() => import("components/service/Service"));
const Navigation = lazy(() => import("pages/navigation/Navigation"));
const GoodsInfo = lazy(() => import("pages/goods-info/GoodsInfo"));
const Search = lazy(() => import("pages/search/Search"));
const SecKill = lazy(() => import("pages/sec-kill/SecKill"));
const User = lazy(() => import("pages/user/User"));
const Cart = lazy(() => import("pages/cart/Cart"));
const Help = lazy(() => import("pages/help/Help"));

function Content(props) {
    const {className} = props;

    return (
        <css.Content className={className}>
            <Suspense fallback={<Loading/>}>
                <Switch>
                    {/* 首页 */}
                    {/*<Route path={[Router.Home.path, '/']} component={Home} exact/>*/}
                    {/* <Route path="/" exact>
            <Redirect to={Router.Home.path} />
          </Route> */}
                    {/* 自营 */}
                    <Route path={MyRouter.Self.path} component={Self}/>
                    {/* 店铺街 */}
                    <Route path={MyRouter.ShopStreet.path} component={ShopStreet}/>
                    {/* 店铺 */}
                    <Route path={MyRouter.Shop.path} component={Shop}/>
                    {/*资讯 */}
                    <Route
                        path={[MyRouter.News.path, MyRouter.News.realPath]}
                        component={News}
                    />
                    {/* 招商入驻 */}
                    <Route path={MyRouter.Merchant.path} component={Merchant}/>
                    {/* 公司简介 */}
                    <Route path={MyRouter.Introduce.path} component={Introduce}/>
                    {/* 订单 */}
                    <Route path={MyRouter.Order.path} component={Order}/>
                    <Route path='/pay/success' exact>
                        <PayNav text='支付信息'/>
                        <PaySuccess/>
                    </Route>
                    <Route path='/wx-pay' exact>
                        <WxPay/>
                    </Route>
                    {/* 我的浏览 */}
                    <Route path={MyRouter.View.path} component={View}/>
                    {/* 收藏 */}
                    <Route path={MyRouter.Collection.path} component={Collection}/>
                    {/* 客户服务 */}
                    {/* <Route path={Router.Service.path} component={Service} /> */}
                    {/* 网站导航 */}
                    <Route path={MyRouter.Navigation.path} component={Navigation}/>
                    {/* 商品详情 */}
                    <Route path={MyRouter.GoodsInfo.path} component={GoodsInfo}/>
                    {/* 搜索 */}
                    <Route path={MyRouter.Search.path} component={Search}/>
                    {/* 秒杀 */}
                    <Route path={MyRouter.SecKill.path} component={SecKill}/>
                    {/* 用户 */}
                    <Route path={MyRouter.User.path} component={User}/>
                    {/* 购物车 */}
                    <Route path={MyRouter.Cart.path} component={Cart}/>
                    {/* 帮助 */}
                    <Route path={MyRouter.Help.path} component={Help}/>
                </Switch>
            </Suspense>
        </css.Content>
    );
}

export default Content;
